import { Component, OnInit, HostListener, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnFileUploaderMiniComponent } from "@bndes/bndes-ux4/bn-file-uploader";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO, ROLE_AGENTE_CONSULTA, ROLE_COTISTA_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ExportService } from 'src/app/features/habilitacao/export.service';
import { LimiteExposicaoService, LimiteResponseDto } from '../limite-exposicao.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { LimiteExposicao, LimiteLegadoDTO } from 'src/app/model/limite-exposicao.model';
import { MensagemService } from 'src/app/features/mensagem.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { ModalidadeGarantia } from 'src/app/model/modalidade_garantia.model';
import { ActivatedRoute } from '@angular/router';




@Component({
    selector: 'app-limite-exposicao-pesquisa',
    templateUrl: './limite-exposicao-pesquisa.component.html',
    styleUrls: ['./limite-exposicao-pesquisa.component.scss'],
    standalone: false
})
export class LimiteExposicaoPesquisaComponent implements OnInit, OnDestroy {

  cnpjUsuario: string;
  agenteFinanceiro: AgenteFinanceiro;
  agentesFinanceiros: AgenteFinanceiro[] = [];
  podePesquisarAgente: boolean = false;
  msgSemResultado: boolean = false;
  dataHoraResultado: string;
  limiteDto: LimiteResponseDto;
  limites: LimiteExposicao[] = [];
  agenteFinanceiroSelect: AgenteFinanceiro;
  podeImportarArquivo: boolean = false;
  ehCotista: boolean = false;
  public modalidade: ModalidadeGarantia;
  public ehFGBS: boolean;
  public valorImportadoExposicaoSetor: number;
  public opcaoExposicaoSetorEnvioArquivo: boolean;

  @ViewChild('botoes') botoesPersonalizados: TemplateRef<any>;
  @ViewChild('body') msgPersonalizada: TemplateRef<any>;

  @ViewChild('botoesExposicaoSetor') botoesPersonalizadosValorExposicaoSetor: TemplateRef<any>;
  @ViewChild('bodyExposicaoSetor') msgPersonalizadaValorExposicaoSetor: TemplateRef<any>;

  @ViewChild('uploaderArquivoSistemaLegado')
  uploaderArquivoSistemaLegado: BnFileUploaderMiniComponent;
  private readonly destroy$ = new Subject();

  @ViewChild('uploaderArquivoExposicaoSetorSistemaLegado')
  uploaderArquivoExposicaoSetorSistemaLegado: BnFileUploaderMiniComponent;

  constructor(private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private bnLoadingService: BnLoadingService,
    private alertsService: BnAlertsService,
    private exportService: ExportService,
    private limiteExposicaoService: LimiteExposicaoService,
    private modalService: BnModalMessageService,
    private agenteFinanceiroService: AgenteFinanceiroService,
    private mensagemService: MensagemService,
    private modalidadeService: ModalidadeService,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.carregar();
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  async carregar() {
    this.bnLoadingService.bloqueiaTela();
    try {
      await Promise.all([
        this.carregarListaAgentesFinanceiros(),
        this.carregarLimiteGlobal()
      ]);

      this.modalidadeService.modalidade$.subscribe((mod) => {
        for (let modalidade of this.modalidadeService.getModalidades()) {
          if (modalidade.sigla == mod) {
            this.modalidade = modalidade;
            this.ehFGBS = this.modalidade.sigla === 'FGBS';
          }
        }
      })
    } catch (err) {
      console.log('erro ao carregar dados', err);
      this.alertsService.alertaErro("Erro", "Erro ao carregar os dados");
    } finally {
      console.log('finalizou carregamento');
      this.bnLoadingService.liberaTela();
    }
  }

  validarOpcaoImportacao(valorOpcao) {

    if (valorOpcao === 'manual') {
      this.opcaoExposicaoSetorEnvioArquivo = false;
    }
    else {
      this.opcaoExposicaoSetorEnvioArquivo = true;
    }

  }

  async carregarLimiteGlobal() {
    const limiteDto = await this.limiteExposicaoService.getLimitePatrimonioLiquidoGlobal().toPromise();
    this.limiteDto = limiteDto;
    this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
  }

  async carregarListaAgentesFinanceiros() {
    await this.getPermissaoUsuarioLogado();

    const agents = await this.agenteFinanceiroService.getAgentesFinanceiros().toPromise();

    if (this.ehCotista) {
      this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'].sort((a, b) =>
        a?.sigla ? a.sigla.localeCompare(b.sigla) : 0); //resolver
    } else {
      this.agentesFinanceiros = agents ? agents.sort((a, b) =>
        a?.sigla ? a.sigla.localeCompare(b.sigla) : 0) : null;
    }
  }

  setAgenteFinancieroLogado() {
    if (this.cnpjUsuario) {
      this.agenteFinanceiroSelect = this.agentesFinanceiros.find(agente => agente.cnpj === this.cnpjUsuario);
      this.carregarLimitesAgentesFinanceiros(this.agenteFinanceiroSelect?.id);
    }
  }

  async getPermissaoUsuarioLogado() {
    this.permissaoService.getPermissoesUsuarioAutenticado()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: any) => {
        this.podeImportarArquivo = resp && resp[ROLE_GESTOR_ENVIO] || resp[ROLE_COTISTA_CONSULTA];
        this.podePesquisarAgente = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO] || resp[ROLE_COTISTA_CONSULTA]);
        this.ehCotista = resp && resp[ROLE_COTISTA_CONSULTA];
        if (resp && resp[ROLE_AGENTE_CONSULTA]) {
          this.bnUsuarioService.usuario$.subscribe(usuario => {
            if (usuario && usuario.cnpj) {
              this.cnpjUsuario = usuario.cnpj;
              this.setAgenteFinancieroLogado();
            }
          });
        }
        if (this.podePesquisarAgente) {
          this.carregarLimitesAgentesFinanceiros();
        }
      });
  }

  async carregarLimitesAgentesFinanceiros(id?: number) {
    const response = await this.limiteExposicaoService.getLimitesAgentesFinanceiros(id).toPromise();
    this.limites = response ? response.sort((a, b) =>
      a?.siglaAgente ? a.siglaAgente.localeCompare(b.siglaAgente) : 0) : null;
    this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
    this.msgSemResultado = (response?.length === 0) || false;
  }

  async buscar() {
    try {
      this.bnLoadingService.bloqueiaTela();
      await Promise.all([
        this.carregarLimiteGlobal(),
        this.carregarLimitesAgentesFinanceiros(this.agenteFinanceiroSelect?.id)
      ]);
    } catch (err) {
      console.log('Erro ao pesquisar', err);
    } finally {
      this.bnLoadingService.liberaTela();
    }
  }

  async exportarLista() {
    try {
      this.bnLoadingService.bloqueiaTela();
      let dadosImportacao: LimiteLegadoDTO = await this.limiteExposicaoService.getUltimoLimiteLegadoImportado().toPromise();
      const response = await this.limiteExposicaoService.getLimitesAgentesFinanceiros(this.agenteFinanceiroSelect?.id).toPromise();
      this.exportService.exportarListaLimitesExposicao(response, dadosImportacao, this.modalidade.sigla);
    } catch (err) {
      console.log('erro ao fazer a exportação', err);
    } finally {
      this.bnLoadingService.liberaTela();
    }
  }

  limparPesquisa() {
    this.limites = [];
    if (!this.cnpjUsuario) {
      this.agenteFinanceiroSelect = null;
    }
    this.msgSemResultado = false;
  }

  temMensagem(limite: LimiteExposicao) {
    return limite.mensagem != null;
  }

  abrirModal() {

    this.modalService.abrir(
      'Importar arquivo do sistema legado',
      'Importar arquivo do sistema legado',
      'lg',
      this.msgPersonalizada,
      this.botoesPersonalizados
    );

  }

  abrirModalImportarValorExposicaoSetor() {

    this.modalService.abrir(
      'Importar valor exposição do sistema legado',
      'Importar valor exposição do sistema legado',
      'lg',
      this.msgPersonalizadaValorExposicaoSetor,
      this.botoesPersonalizadosValorExposicaoSetor
    );

  }


  close() {
    this.modalService.close();
  }


  async importarArquivoLegado() {

    if (this.uploaderArquivoSistemaLegado.listaPendente.length < 1) {
      this.mensagemService.adicionarMensagemAviso('O arquivo a ser importado não foi adicionado.');
      return;
    }

    try {
      this.bnLoadingService.bloqueiaTela();
      await this.limiteExposicaoService.importarArquivoLegado(this.uploaderArquivoSistemaLegado);
      this.close();
      this.buscar();
      this.mensagemService.adicionarMensagemSucesso('Importação de arquivo legado realizada com sucesso.');
      this.bnLoadingService.liberaTela();


    } catch (error) {
      this.mensagemService.adicionarMensagemErro('Erro ao importar arquivo legado. Favor, verificar arquivo.');
      this.bnLoadingService.liberaTela();
      return;
    }

  }

  async importarValorExposicaoSetor() {

    if (this.opcaoExposicaoSetorEnvioArquivo) {
      this.importarArquivoLegadoExposicaoSetor();
      return;
    }

    if (this.valorImportadoExposicaoSetor == null) {
      this.mensagemService.adicionarMensagemAviso('Nenhum valor a ser importado para Exposição por Setor foi informado.');
      return;
    }

    if (this.valorImportadoExposicaoSetor <= 0) {
      return;
    }

    try {

      this.bnLoadingService.bloqueiaTela();
      await this.limiteExposicaoService.importarValorLegadoExposicaoSetor(this.valorImportadoExposicaoSetor).toPromise();
      this.close();
      await this.buscar();
      this.bnLoadingService.liberaTela();
      this.valorImportadoExposicaoSetor = null;
      this.mensagemService.adicionarMensagemSucesso('Importação de valor para Exposição por Setor efetuada com sucesso.');


    } catch (error) {
      this.mensagemService.adicionarMensagemErro('Erro ao importar valor para Exposição por Setor.');
      this.bnLoadingService.liberaTela();
      return;
    }

    finally {
      this.close();
      this.valorImportadoExposicaoSetor = null;
      this.bnLoadingService.liberaTela();
    }

  }

  async importarArquivoLegadoExposicaoSetor() {


    if (this.uploaderArquivoExposicaoSetorSistemaLegado.listaPendente.length < 1) {
      this.mensagemService.adicionarMensagemAviso('O arquivo a ser importado não foi adicionado.');
      return;
    }

    try {
      this.bnLoadingService.bloqueiaTela();
      await this.limiteExposicaoService.importarArquivoLegadoExposicaoSetor(this.uploaderArquivoExposicaoSetorSistemaLegado);
      this.close();
      this.buscar();
      this.mensagemService.adicionarMensagemSucesso('Importação de arquivo legado realizada com sucesso.');
      this.bnLoadingService.liberaTela();


    } catch (error) {
      this.mensagemService.adicionarMensagemErro('Erro ao importar arquivo legado. Favor, verificar arquivo.');
      this.bnLoadingService.liberaTela();
      return;
    }


  }


}
